import {AnyLinkType} from 'shared/pretty-easy-navigation/models';

export const GuestMenu: AnyLinkType[] = [
    {
        type: 'link',
        label: 'navigation.legal_notice',
        link: '/informations-legales',
    },
    {
        type: 'link',
        label: 'navigation.contact',
        link: '{{GAR_CONTACT}}',
    },
    {
        type: 'link',
        label: 'navigation.site_map',
        link: '{{SITE_MAP_LINK}}',
    },
];
